// Shared navigation model. Labels are i18n keys (resolve with t(labelKey)).

export const pageLinks = [
  { id: "story", labelKey: "nav.story", to: "/story" },
  { id: "services", labelKey: "nav.services", to: "/services" },
  { id: "blog", labelKey: "nav.blog", to: "/blog" },
];

export const anchorLinks = [
  { id: "process", labelKey: "nav.process", hash: "#process" },
  { id: "projects", labelKey: "nav.projects", hash: "#projects" },
  { id: "faq", labelKey: "nav.faq", hash: "#faq" },
];

export const aiCta = { id: "ai", labelKey: "nav.aiCta", hash: "#ai" };

// Section ids tracked by the side rail / active-section logic (Home order).
export const homeSections = [
  { id: "home", labelKey: "nav.home" },
  { id: "about", labelKey: "nav.story" },
  { id: "services", labelKey: "nav.services" },
  { id: "process", labelKey: "nav.process" },
  { id: "projects", labelKey: "nav.projects" },
  { id: "ai", labelKey: "nav.aiCta" },
  { id: "faq", labelKey: "nav.faq" },
  { id: "contact", labelKey: "nav.contact" },
];
